var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCoatHanger = function SvgIconCoatHanger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 4.75a2 2 0 0 0-2 2 1 1 0 1 1-2 0 4 4 0 0 1 8 0 1 1 0 0 1-.4.8L13.667 9l9.133 6.85A1.75 1.75 0 0 1 21.75 19H2.25a1.75 1.75 0 0 1-1.05-3.15l10.182-7.637.037-.027 2.527-1.896A2 2 0 0 0 12 4.75m0 5.5L3 17h18z",
    clipRule: "evenodd"
  })));
};
export default SvgIconCoatHanger;